import React from 'react';

const ResponsiveGrid = ({ 
  children, 
  className = '',
  cols = { default: 1, sm: 2, md: 3, lg: 4 },
  gap = 6,
  autoFit = false
}) => {
  const getGridColsClass = () => {
    if (autoFit) {
      return 'grid-cols-[repeat(auto-fit,minmax(250px,1fr))]';
    }

    const colsClasses = [];
    
    if (cols.default) {
      colsClasses.push(`grid-cols-${cols.default}`);
    }
    if (cols.sm) {
      colsClasses.push(`sm:grid-cols-${cols.sm}`);
    }
    if (cols.md) {
      colsClasses.push(`md:grid-cols-${cols.md}`);
    }
    if (cols.lg) {
      colsClasses.push(`lg:grid-cols-${cols.lg}`);
    }
    if (cols.xl) {
      colsClasses.push(`xl:grid-cols-${cols.xl}`);
    }
    if (cols['2xl']) {
      colsClasses.push(`2xl:grid-cols-${cols['2xl']}`);
    }

    return colsClasses.join(' ');
  };

  const getGapClass = () => {
    return `gap-${gap}`;
  };

  return (
    <div className={`grid ${getGridColsClass()} ${getGapClass()} ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveGrid;
